import { Pipe, PipeTransform } from '@angular/core';
import { MediaMarket } from '../../../../Discover/Core/models/media-market.model';

@Pipe({
    name: 'mediaMarketDisplay',
    standalone: false
})
export class MediaMarketsDisplayPipe implements PipeTransform {

    transform(mediaMarkets: MediaMarket[]): any {
        const displayArray = [];
        if (mediaMarkets?.length > 0) {
            mediaMarkets.forEach(market => {
                let typeIndex = -1;
                if (displayArray.length > 0) {
                    typeIndex = displayArray.findIndex(marketDisplay => marketDisplay.header === market.getTypeDisplayString());
                }
                if (typeIndex > -1) {
                    displayArray[typeIndex].content.push(market.displayString);
                } else {
                    displayArray.push({header: market.getTypeDisplayString(), content: [market.displayString]});
                }
            });
        }
        return displayArray;
    }

}
